var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectParking1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1199,
    height: 861,
    viewBox: "0 0 1199 861",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 61,
    d: "M989.918 169.853V173.751V186.678V206.789H1065.33V186.678V169.853H989.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 60,
    d: "M989.918 131.404V136.52V149.605V169.961H1065.14V149.605V131.404H989.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 58,
    d: "M842.918 169.853V173.751V186.678V206.789H918.329V186.678V169.853H842.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 59,
    d: "M842.918 131.404V136.52V149.605V169.961H918.136V149.605V131.404H842.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 51,
    d: "M743.245 352.622L746.967 352.622L757.937 352.622L771.293 352.622L771.293 295.779L757.937 295.779L743.245 295.779L743.245 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 50,
    d: "M711.718 352.622L715.822 352.622L727.921 352.622L742.65 352.622L742.65 295.779L727.921 295.779L711.718 295.779L711.718 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 27,
    d: "M566.718 483L572.297 483L588.742 483L608.762 483L608.762 421.329L588.742 421.329L566.718 421.329L566.718 483Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 26,
    d: "M608.431 482.998L612.303 482.998L623.718 482.998L637.615 482.998L637.615 421.329L623.718 421.329L608.431 421.329L608.431 482.998Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 25,
    d: "M638.223 494.912L642.908 494.912L656.718 494.912L673.53 494.912L673.53 421.329L656.718 421.329L638.223 421.329L638.223 494.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 24,
    d: "M673.53 494.912L678.23 494.912L692.084 494.912L708.949 494.912L708.949 421.329L692.084 421.329L673.53 421.329L673.53 494.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 23,
    d: "M709.223 494.912L713.422 494.912L725.8 494.912L740.868 494.912L740.868 421.329L725.8 421.329L709.223 421.329L709.223 494.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 22,
    d: "M740.868 494.912L745.081 494.912L757.498 494.912L772.614 494.912L772.614 421.329L757.498 421.329L740.868 421.329L740.868 494.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M710.706 568.88L718.099 568.88L738.833 568.88L766.42 568.88L766.42 495.693L738.833 495.693L710.706 495.693L710.706 568.88Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: 48,
    d: "M638.718 352.622L643.399 352.622L657.197 352.622L673.994 352.622L673.994 295.779L657.197 295.779L638.718 295.779L638.718 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: 49,
    d: "M673.994 352.622L678.889 352.622L693.317 352.622L710.882 352.622L710.882 295.779L693.317 295.779L673.994 295.779L673.994 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: 29,
    d: "M493.223 494.912L498.102 494.912L512.485 494.912L529.994 494.912L529.994 421.329L512.485 421.329L493.223 421.329L493.223 494.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: 28,
    d: "M529.994 494.912L534.889 494.912L549.317 494.912L566.882 494.912L566.882 421.329L549.317 421.329L529.994 421.329L529.994 494.912Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M203.718 568.974L208.399 568.974L222.197 568.974L238.994 568.974L238.994 497.47L222.197 497.47L203.718 497.47L203.718 568.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M238.994 568.974L243.889 568.974L258.317 568.974L275.882 568.974L275.882 497.47L258.317 497.47L238.994 497.47L238.994 568.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M347.768 568.974L352.681 568.974L367.163 568.974L384.793 568.974L384.793 497.47L367.163 497.47L347.768 497.47L347.768 568.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M384.92 568.974L389.566 568.974L403.26 568.974L419.932 568.974L419.932 497.47L403.26 497.47L384.92 497.47L384.92 568.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: 44,
    d: "M490.718 352.622L495.399 352.622L509.197 352.622L525.994 352.622L525.994 295.779L509.197 295.779L490.718 295.779L490.718 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: 45,
    d: "M525.994 352.622L530.889 352.622L545.317 352.622L562.882 352.622L562.882 295.779L545.317 295.779L525.994 295.779L525.994 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: 42,
    d: "M417.884 352.622L422.565 352.622L436.363 352.622L453.16 352.622L453.16 295.779L436.363 295.779L417.884 295.779L417.884 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: 43,
    d: "M453.16 352.622L458.055 352.622L472.483 352.622L490.048 352.622L490.048 295.779L472.483 295.779L453.16 295.779L453.16 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: 40,
    d: "M345.814 352.622L350.495 352.622L364.293 352.622L381.091 352.622L381.091 295.779L364.293 295.779L345.814 295.779L345.814 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: 41,
    d: "M381.091 352.622L385.986 352.622L400.414 352.622L417.978 352.622L417.978 295.779L400.414 295.779L381.091 295.779L381.091 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: 38,
    d: "M273.718 352.622L278.399 352.622L292.197 352.622L308.994 352.622L308.994 295.779L292.197 295.779L273.718 295.779L273.718 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: 39,
    d: "M308.994 352.622L313.889 352.622L328.317 352.622L345.882 352.622L345.882 295.779L328.317 295.779L308.994 295.779L308.994 352.622Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: 90,
    d: "M530.814 696.78L535.045 696.78L546.248 696.78L562.697 696.78L562.697 637.28L546.248 637.28L530.814 637.28L530.814 696.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: 88,
    d: "M492.647 696.955L497.693 696.955L511.052 696.955L530.67 696.955L530.67 637.28L511.052 637.28L492.647 637.28L492.647 696.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: 76,
    d: "M276.768 696.694L281.48 696.694L295.371 696.694L312.282 696.694L312.282 637.47L295.371 637.47L276.768 637.47L276.768 696.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: 78,
    d: "M312.607 696.694L316.609 696.694L328.404 696.694L342.763 696.694L342.763 637.47L328.404 637.47L312.607 637.47L312.607 696.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: 31,
    d: "M420.604 495.426L425.301 495.426L439.143 495.426L455.994 495.426L455.994 421.322L439.143 421.322L420.604 421.322L420.604 495.426Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: 30,
    d: "M455.994 494.915L460.889 494.915L475.317 494.915L492.882 494.915L492.882 421.322L475.317 421.322L455.994 421.322L455.994 494.915Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M131.718 568.974L136.399 568.974L150.197 568.974L166.994 568.974L166.994 497.47L150.197 497.47L131.718 497.47L131.718 568.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M166.994 568.974L171.889 568.974L186.317 568.974L203.882 568.974L203.882 497.47L186.317 497.47L166.994 497.47L166.994 568.974Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: 77,
    d: "M276.768 756.694L281.48 756.694L295.371 756.694L312.282 756.694L312.282 697.47L295.371 697.47L276.768 697.47L276.768 756.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: 79,
    d: "M312.607 756.694L316.609 756.694L328.404 756.694L342.763 756.694L342.763 697.47L328.404 697.47L312.607 697.47L312.607 756.694Z",
    fill: "#E32009",
    fillOpacity: 0.3,
    stroke: "#E32009",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: 91,
    d: "M530.557 756.487L534.759 756.487L545.885 756.487L562.224 756.487L562.224 697.28L545.885 697.28L530.557 697.28L530.557 756.487Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: 89,
    d: "M492.647 756.661L497.659 756.661L510.928 756.661L530.412 756.661L530.412 697.28L510.928 697.28L492.647 697.28L492.647 756.661Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: 108,
    d: "M881.841 696.78L887.059 696.78L900.876 696.78L921.166 696.78L921.166 637.28L900.876 637.28L881.841 637.28L881.841 696.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: 106,
    d: "M844.454 696.955L849.415 696.955L862.551 696.955L881.841 696.955L881.841 637.28L862.551 637.28L844.454 637.28L844.454 696.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: 63,
    d: "M989.918 315.858V320.072V334.048V355.789H1065.15V334.048V315.858H989.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: 65,
    d: "M990 386V389.799V402.399V422H1065V402.399V386H990Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: 62,
    d: "M989.918 280.404V285.124V297.194V315.972H1065.14V297.194V280.404H989.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: 64,
    d: "M990 356V359.981V370.162V386H1065V370.162V356H990Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: 113,
    d: "M954.894 757.09L959.972 757.09L973.419 757.09L993.166 757.09L993.166 696.28L973.419 696.28L954.894 696.28L954.894 757.09Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: 111,
    d: "M921.007 757.268L925.503 757.268L937.41 757.268L954.894 757.268L954.894 696.28L937.41 696.28L921.007 696.28L921.007 757.268Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: 112,
    d: "M954.841 696.494L960.059 696.494L973.876 696.494L994.166 696.494L994.166 637.28L973.876 637.28L954.841 637.28L954.841 696.494Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: 110,
    d: "M921.239 696.494L925.698 696.494L937.504 696.494L954.841 696.494L954.841 637.28L937.504 637.28L921.239 637.28L921.239 696.494Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: 87,
    d: "M458.226 756.682L462.581 756.682L473.718 756.682L491.045 756.682L491.045 696.058L473.718 696.058L458.226 696.058L458.226 756.682Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: 85,
    d: "M417.292 756.726L422.734 756.726L436.651 756.726L458.302 756.726L458.302 696.06L436.651 696.06L417.292 696.06L417.292 756.726Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: 86,
    d: "M458.204 695.821L462.559 695.821L473.697 695.821L491.024 695.821L491.024 637.393L473.697 637.393L458.204 637.393L458.204 695.821Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: 84,
    d: "M417.271 695.925L422.712 695.925L436.63 695.925L458.281 695.925L458.281 637.395L436.63 637.395L417.271 637.395L417.271 695.925Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: 83,
    d: "M384.619 756.719L388.974 756.719L400.112 756.719L417.439 756.719L417.439 695.937L400.112 695.937L384.619 695.937L384.619 756.719Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: 81,
    d: "M344.77 756.705L350.068 756.705L363.617 756.705L384.696 756.705L384.696 695.938L363.617 695.938L344.77 695.938L344.77 756.705Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: 82,
    d: "M384.919 695.821L389.179 695.821L400.074 695.821L417.024 695.821L417.024 637.166L400.074 637.166L384.919 637.166L384.919 695.821Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: 80,
    d: "M344.877 695.925L350.2 695.925L363.815 695.925L384.994 695.925L384.994 637.395L363.815 637.395L344.877 637.395L344.877 695.925Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: 71,
    d: "M167.496 756.966L173.221 756.966L187.86 756.966L210.636 756.966L210.636 698.615L187.86 698.615L167.496 698.615L167.496 756.966Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: 69,
    d: "M139.877 757.07L143.577 757.07L153.039 757.07L167.759 757.07L167.759 698.395L153.039 698.395L139.877 698.395L139.877 757.07Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: 56,
    d: "M842.918 243.24V248.014V260.223V279.217H918.329V260.223V243.24H842.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: 57,
    d: "M842.918 207.404V212.178V224.387V243.381H918.136V224.387V207.404H842.918Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: 47,
    d: "M608.574 352.62L612.307 352.62L624.603 352.62L636.702 352.62L636.702 295.971L624.603 295.971L608.574 295.971L608.574 352.62Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: 46,
    d: "M564.881 352.62L570.679 352.62L589.78 352.62L608.574 352.62L608.574 295.971L589.78 295.971L564.881 295.971L564.881 352.62Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: 18,
    d: "M883.157 497.016L888.139 497.016L900.879 497.016L920.698 497.016L920.698 421.009L900.879 421.009L883.157 421.009L883.157 497.016Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: 19,
    d: "M841.591 497.016L847.119 497.016L861.258 497.016L883.253 497.016L883.253 421.204L861.258 421.204L841.591 421.204L841.591 497.016Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: 16,
    d: "M842.195 533.24V538.014V550.223V569.217H920.329V550.223V533.24H842.195Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: 17,
    d: "M842.195 497.404V502.178V514.387V533.381H920.129V514.387V497.404H842.195Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M458.615 568.74L463.161 568.74L474.788 568.74L492.874 568.74L492.874 497.166L474.788 497.166L458.615 497.166L458.615 568.74Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M421.877 568.867L426.735 568.867L439.16 568.867L458.489 568.867L458.489 497.445L439.16 497.445L421.877 497.445L421.877 568.867Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M529.615 568.74L534.161 568.74L545.788 568.74L563.874 568.74L563.874 497.166L545.788 497.166L529.615 497.166L529.615 568.74Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M492.591 568.867L497.487 568.867L510.009 568.867L529.489 568.867L529.489 497.161L510.009 497.161L492.591 497.161L492.591 568.867Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M674.615 568.74L679.161 568.74L690.788 568.74L708.874 568.74L708.874 496.836L690.788 496.836L674.615 496.836L674.615 568.74Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M637.591 568.867L642.487 568.867L655.009 568.867L674.489 568.867L674.489 496.822L655.009 496.822L637.591 496.822L637.591 568.867Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: 20,
    d: "M804.886 496.653L809.766 496.653L822.247 496.653L841.663 496.653L841.663 421.009L822.247 421.009L804.886 421.009L804.886 496.653Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: 21,
    d: "M774.506 496.757L778.526 496.757L788.808 496.757L804.804 496.757L804.804 421.204L788.808 421.204L774.506 421.204L774.506 496.757Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: 53,
    d: "M805.165 352.652L815.19 352.652L840.829 352.652L840.829 295.754L805.165 295.754L805.165 352.652Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: 100,
    d: "M713.234 696.136L728.355 696.136L767.026 696.136L767.026 637.35L713.234 637.35L713.234 696.136Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: 101,
    d: "M713.234 757.409L728.355 757.409L767.026 757.409L767.026 696.766L713.234 696.766L713.234 757.409Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: 67,
    d: "M989.955 458.914V463.783V476.675V495.606H1065.33V476.675V458.914H989.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: 66,
    d: "M989.955 424.119V428.712V440.873V458.731H1065.33V440.873V424.119H989.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: 54,
    d: "M842.955 315.914V320.783V333.675V352.606H918.334V333.675V315.914H842.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: 55,
    d: "M842.955 281.119V285.712V297.873V315.731H918.334V297.873V281.119H842.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: 74,
    d: "M240.356 696.78L244.988 696.78L257.252 696.78L275.262 696.78L275.262 637.28L257.252 637.28L240.356 637.28L240.356 696.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: 72,
    d: "M212.647 696.955L216.339 696.955L226.112 696.955L240.464 696.955L240.464 637.28L226.112 637.28L212.647 637.28L212.647 696.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: 32,
    d: "M382.069 495.583L386.924 495.583L399.778 495.583L418.653 495.583L418.653 421.28L399.778 421.28L382.069 421.28L382.069 495.583Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: 33,
    d: "M347.378 495.801L351.957 495.801L364.083 495.801L381.888 495.801L381.888 421.28L364.083 421.28L347.378 421.28L347.378 495.801Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: 68,
    d: "M167.317 637.455L163.646 637.455L153.924 637.455L139.648 637.455L139.648 696.955L153.924 696.955L167.317 696.955L167.317 637.455Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: 70,
    d: "M212.89 637.28L206.87 637.28L190.929 637.28L167.522 637.28L167.522 696.955L190.929 696.955L212.89 696.955L212.89 637.28Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: 34,
    d: "M318.781 495.796L322.33 495.796L331.727 495.796L345.525 495.796L345.525 421.29L331.727 421.29L318.781 421.29L318.781 495.796Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: 35,
    d: "M275.48 495.669L281.226 495.669L296.44 495.669L318.781 495.669L318.781 421.29L296.44 421.29L275.48 421.29L275.48 495.669Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: 36,
    d: "M238.573 495.678L243.344 495.678L255.976 495.678L274.525 495.678L274.525 421.173L255.976 421.173L238.573 421.173L238.573 495.678Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: 37,
    d: "M204.48 495.678L208.981 495.678L220.897 495.678L238.395 495.678L238.395 421.173L220.897 421.173L204.48 421.173L204.48 495.678Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: 75,
    d: "M240.356 756.778L244.988 756.778L257.252 756.778L275.262 756.778L275.262 698.28L257.252 698.28L240.356 698.28L240.356 756.778Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: 73,
    d: "M212.647 756.949L216.339 756.949L226.112 756.949L240.464 756.949L240.464 698.28L226.112 698.28L212.647 698.28L212.647 756.949Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: 104,
    d: "M804.841 696.78L810.059 696.78L823.876 696.78L844.166 696.78L844.166 637.28L823.876 637.28L804.841 637.28L804.841 696.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: 102,
    d: "M768.647 696.955L773.45 696.955L786.167 696.955L804.841 696.955L804.841 637.28L786.167 637.28L768.647 637.28L768.647 696.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: 98,
    d: "M675.554 696.78L680.279 696.78L692.792 696.78L711.166 696.78L711.166 637.28L692.792 637.28L675.554 637.28L675.554 696.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: 96,
    d: "M635.647 696.955L640.923 696.955L654.891 696.955L675.402 696.955L675.402 637.28L654.891 637.28L635.647 637.28L635.647 696.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: 94,
    d: "M602.554 696.78L606.977 696.78L618.69 696.78L635.889 696.78L635.889 637.28L618.69 637.28L602.554 637.28L602.554 696.78Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: 92,
    d: "M562.647 696.955L567.923 696.955L581.891 696.955L602.402 696.955L602.402 637.28L581.891 637.28L562.647 637.28L562.647 696.955Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: 95,
    d: "M602.514 756.487L606.937 756.487L618.65 756.487L635.849 756.487L635.849 697.28L618.65 697.28L602.514 697.28L602.514 756.487Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: 93,
    d: "M562.607 756.661L567.883 756.661L581.851 756.661L602.362 756.661L602.362 697.28L581.851 697.28L562.607 697.28L562.607 756.661Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: 99,
    d: "M675.554 757.482L680.277 757.482L692.783 757.482L711.148 757.482L711.148 698.275L692.783 698.275L675.554 698.275L675.554 757.482Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: 97,
    d: "M635.647 757.656L640.923 757.656L654.891 757.656L675.402 757.656L675.402 698.275L654.891 698.275L635.647 698.275L635.647 757.656Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: 52,
    d: "M773.418 352.607L782.39 352.607L803.15 352.607L803.15 295.724L773.418 295.724L773.418 352.607Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: 115,
    d: "M1027.84 696.378L1032.83 696.378L1046.04 696.378L1065.44 696.378L1065.44 637.28L1046.04 637.28L1027.84 637.28L1027.84 696.378Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: 114,
    d: "M994.197 696.349L998.662 696.349L1010.48 696.349L1027.84 696.349L1027.84 637.28L1010.48 637.28L994.197 637.28L994.197 696.349Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: 109,
    d: "M882.277 757.266L887.432 757.266L901.081 757.266L921.123 757.266L921.123 697.28L901.081 697.28L882.277 697.28L882.277 757.266Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: 107,
    d: "M844.647 757.249L849.567 757.249L862.591 757.249L881.718 757.249L881.718 697.28L862.591 697.28L844.647 697.28L844.647 757.249Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: 105,
    d: "M804.841 757.26L810.059 757.26L823.876 757.26L844.166 757.26L844.166 697.28L823.876 697.28L804.841 697.28L804.841 757.26Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: 103,
    d: "M768.647 757.436L773.45 757.436L786.167 757.436L804.841 757.436L804.841 697.28L786.167 697.28L768.647 697.28L768.647 757.436Z",
    fill: "#90D840",
    fillOpacity: 0.3,
    stroke: "#90D840",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: 15,
    d: "M798.336 568.76L804.15 568.76L819.021 568.76L842.154 568.76L842.154 496.848L819.021 496.848L798.336 496.848L798.336 568.76Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: 14,
    d: "M767.95 568.886L771.995 568.886L782.338 568.886L798.429 568.886L798.429 496.919L782.338 496.919L767.95 496.919L767.95 568.886Z",
    fill: "#F6AD34",
    fillOpacity: 0.3,
    stroke: "#F6AD34",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectParking1);
export default __webpack_public_path__ + "static/media/select-parking-1.5116b2fd.svg";
export { ForwardRef as ReactComponent };